<div class="row p-3">
    <div class="col d-flex justify-content-center">
        <label class="k-form-field">
            <span class="k-text-uppercase dark">
                {{'AS-OF-DATE' | translate}}
            </span>
            <kendo-datepicker class="w-50" [max]="maxDate" [(ngModel)]="asOfDate" [required]="true"
                (valueChange)="onAsOfDateChange($event)">
            </kendo-datepicker>
        </label>
    </div>
    <app-accumulator-grid [dataView]="viewAccumulators" [newTitleKey]="'USED-TOTAL'" [durationLoaded]="durationLoaded">
    </app-accumulator-grid>
</div>